<h1> REGISTRATION </h1>
<p>
  Participation in the CIFRIS25 Conference is <b>free</b> and open to all current members and to anyone who will join DeCifris. People not able/willing to join De Cifris (e.g., non-EU nationals) are welcome to fill the form specifying their situation: we will admit as many as possible.
</p>
<h3> Registration is permanently closed </h3>
  
